<template>
  <div class="card">
    <div class="card-header">
      <i class="fa-regular fa-pen-to-square me-2"/>{{ title }}
    </div>
    <div class="card-body" :class="formClass">
      <slot name="fields"></slot>
      <button
        :disabled="disabled"
        @click="$emit('submit')"
        class="btn btn-primary w-100 py-2 mt-3">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminCreateCard',
  props: {
    title: {
      type: String,
      default: '新規登録',
    },
    buttonText: {
      type: String,
      default: '登録',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    formClass: {
      type: String,
      default: '',
    },
  },
  emits: ['submit'],
};
</script>

<style lang="scss" scoped>
.card {
  border: 2px solid rgba(152, 121, 89, 1);
}
</style>
